// Path-prefix-filterin (vaihtoehto 2) breadcrumb /selaa:lle.
// Klikkaaminen segmenttiä = navigointi siihen alipuuhun. "Tyhjennä polku"
// poistaa filterin kokonaan.
//
// Polku-validointi tehdaen filter-state.ts:ssa (parseFilters torjuu
// muut kuin /-alkuiset). Tassae oletetaan etta tultaessa polku on
// validi absoluuttinen polku.

export type PathBreadcrumbProps = {
  /** Aktiivinen polku-filter (esim. "/Users/kimmo/Pictures"). */
  path: string;
  /** Vaihda polkua tai tyhjenne (null). */
  onChange: (next: string | null) => void;
};

export function PathBreadcrumb({ path, onChange }: PathBreadcrumbProps) {
  // Hajota polku segmenteihin. "/Users/kimmo/Pictures" → ["Users", "kimmo", "Pictures"]
  // Tyhjat ohitetaan (johtaa-/ tai trailing-/).
  const segments = path.split("/").filter(Boolean);
  // Akkumuloi prefix-polut jotta klikkaus rakentaa sen polun.
  // Esim. ["Users","kimmo","Pictures"] → ["/Users","/Users/kimmo","/Users/kimmo/Pictures"]
  const prefixes = segments.map((_, i) => "/" + segments.slice(0, i + 1).join("/"));

  return (
    <nav
      aria-label="Polku-breadcrumb"
      className="flex flex-wrap items-center gap-1 text-sm text-slate-400"
    >
      <span className="text-xs uppercase tracking-wide text-slate-500">Kansio:</span>
      <button
        type="button"
        onClick={() => onChange(null)}
        title="Tyhjennä polku-filter"
        className="rounded px-2 py-0.5 text-slate-300 hover:bg-slate-800 hover:text-slate-100"
      >
        /
      </button>
      {segments.map((seg, i) => {
        const isLast = i === segments.length - 1;
        return (
          <span key={prefixes[i]} className="flex items-center gap-1">
            <span className="text-slate-600">/</span>
            {isLast ? (
              <span className="rounded bg-slate-800 px-2 py-0.5 text-slate-100">{seg}</span>
            ) : (
              <button
                type="button"
                onClick={() => onChange(prefixes[i]!)}
                title={`Porautuu ${prefixes[i]} alipuuhun`}
                className="rounded px-2 py-0.5 text-slate-300 hover:bg-slate-800 hover:text-slate-100"
              >
                {seg}
              </button>
            )}
          </span>
        );
      })}
      <button
        type="button"
        onClick={() => onChange(null)}
        className="ml-2 rounded border border-slate-700 px-2 py-0.5 text-xs text-slate-400 hover:bg-slate-800 hover:text-slate-200"
      >
        Tyhjennä polku
      </button>
    </nav>
  );
}

/** Palauta dirname-polku (poista viimeinen segmentti). Käytetään asset-modaalista
 *  "porautuu tämän kansioon" -toiminnossa: `assets.currentPath` → kansiopolku. */
export function parentDir(path: string): string {
  const normalized = path.replace(/\/+$/, "");
  const idx = normalized.lastIndexOf("/");
  if (idx <= 0) return "/";
  return normalized.slice(0, idx);
}
